import { connect } from "react-redux"
import CurrencyFormatter from "currency-formatter";

function MonthlyBalanceSheetConsolidation({ currentCompanyMonthlyBalanceSheet }) {

  return (
    <div className="pb-10">
      <div className="flex items-center w-full mt-10">
        <div style={{ minWidth: "20em" }}></div>
        {currentCompanyMonthlyBalanceSheet.datesFormatted.map((date) => (
          <div className="w-40 font-semibold" style={{ minWidth: "10em" }}>
            <label>{date}</label>
          </div>
        ))}
      </div>
      <div>
        <label className="font-bold text-xl">Fixed Assets</label>
        <div className="mt-5">
          {currentCompanyMonthlyBalanceSheet?.fixedAssetsCategoryNames?.map((category, balanceSheetAssetItemIndex) => (
            <div key={balanceSheetAssetItemIndex} className="items-center mb-4">
              <div className="flex">
                <div className="whitespace-nowrap items-center" style={{ minWidth: "20em" }}>
                  <label>{category?.name}</label>
                </div>
                {currentCompanyMonthlyBalanceSheet?.getAssetsCategoryValues(category?.value, "Fixed Assets").map((category) => (
                  <div className="items-center" style={{ minWidth: "10em" }}>
                    <label>{CurrencyFormatter.format(category?.value, { code: "USD" })}</label>
                  </div>
                ))}
              </div>
              <div className="flex">
                <div className="whitespace-nowrap items-center" style={{ minWidth: "20em" }}>
                  <label className="text-xs">Ratio to Total Assets</label>
                </div>
                {currentCompanyMonthlyBalanceSheet?.getAssetsCategoryValues(category?.value, "Fixed Assets").map((category, index) => (
                  <div className="items-center" style={{ minWidth: "10em" }}>
                    <label className="text-xs">
                      {(100 * category?.value / currentCompanyMonthlyBalanceSheet?.getTotalAssets()[index].value).toFixed(2)}%
                    </label>
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div className="flex items-center mt-2">
            <div className="whitespace-nowrap flex items-center border-t pt-4" style={{ minWidth: "20em" }}>
              <label className="font-semibold">Total Fixed Assets</label>
            </div>
            <div className="flex border-t pt-4">
              {currentCompanyMonthlyBalanceSheet?.getTotalAssets("Fixed Assets").map((asset) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
                </div>
              ))}
            </div>
          </div>
          <div className="flex items-center mt-1 pb-4">
            <div className="whitespace-nowrap flex items-center" style={{ minWidth: "20em" }}>
              <label className="text-xs">Ratio to Total Assets</label>
            </div>
            <div className="flex">
              {currentCompanyMonthlyBalanceSheet?.getTotalAssets("Fixed Assets").map((asset, index) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {(100 * asset?.value / currentCompanyMonthlyBalanceSheet?.getTotalAssets()[index].value).toFixed(2)}%
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <label className="font-bold text-xl">Current Assets</label>
        <div className="mt-5">
          {currentCompanyMonthlyBalanceSheet?.currentAssetsCategoryNames?.map((category, balanceSheetAssetItemIndex) => (
            <div key={balanceSheetAssetItemIndex} className="items-center mb-4">
              <div className="flex">
                <div className="whitespace-nowrap items-center" style={{ minWidth: "20em" }}>
                  <label>{category?.name}</label>
                </div>
                {currentCompanyMonthlyBalanceSheet?.getAssetsCategoryValues(category?.value, "Current Assets").map((category) => (
                  <div className="items-center" style={{ minWidth: "10em" }}>
                    <label>{CurrencyFormatter.format(category?.value, { code: "USD" })}</label>
                  </div>
                ))}
              </div>
              <div className="flex">
                <div className="whitespace-nowrap items-center" style={{ minWidth: "20em" }}>
                  <label className="text-xs">Ratio to Total Assets</label>
                </div>
                {currentCompanyMonthlyBalanceSheet?.getAssetsCategoryValues(category?.value, "Current Assets").map((category, index) => (
                  <div className="items-center" style={{ minWidth: "10em" }}>
                    <label className="text-xs">
                      {(100 * category?.value / currentCompanyMonthlyBalanceSheet?.getTotalAssets()[index].value).toFixed(2)}%
                    </label>
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div className="flex items-center mt-2">
            <div className="whitespace-nowrap flex items-center border-t pt-4" style={{ minWidth: "20em" }}>
              <label className="font-semibold">Total Current Assets</label>
            </div>
            <div className="flex border-t pt-4">
              {currentCompanyMonthlyBalanceSheet?.getTotalAssets("Current Assets").map((asset) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
                </div>
              ))}
            </div>
          </div>
          <div className="flex items-center mt-1 pb-4">
            <div className="whitespace-nowrap flex items-center" style={{ minWidth: "20em" }}>
              <label className="text-xs">Ratio to Total Assets</label>
            </div>
            <div className="flex">
              {currentCompanyMonthlyBalanceSheet?.getTotalAssets("Current Assets").map((asset, index) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {(100 * asset?.value / currentCompanyMonthlyBalanceSheet?.getTotalAssets()[index].value).toFixed(2)}%
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center mt-10">
        <div className="whitespace-nowrap flex items-center border-t pt-4" style={{ minWidth: "20em" }}>
          <label className="font-semibold">Total Assets</label>
        </div>
        <div className="flex border-t pt-4">
          {currentCompanyMonthlyBalanceSheet?.getTotalAssets().map((asset) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center mt-1">
        <div className="whitespace-nowrap flex items-center border-b pb-4" style={{ minWidth: "20em" }}>
          <label className="text-xs">Ratio to Total Assets</label>
        </div>
        <div className="flex border-b pb-4">
          {currentCompanyMonthlyBalanceSheet?.getTotalAssets().map((asset, index) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label className="text-xs">
                {(100 * asset?.value / currentCompanyMonthlyBalanceSheet?.getTotalAssets()[index].value).toFixed(2)}%
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-10">
        <label className="font-bold text-xl">Current Liabilities</label>
        <div className="mt-5">
          {currentCompanyMonthlyBalanceSheet?.currentLiabilitiesCategoryNames?.map((category, balanceSheetAssetItemIndex) => (
            <div key={balanceSheetAssetItemIndex} className="items-center mb-4">
              <div className="flex">
                <div className="whitespace-nowrap items-center" style={{ minWidth: "20em" }}>
                  <label>{category?.name}</label>
                </div>
                {currentCompanyMonthlyBalanceSheet?.getLiabilitiesCategoryValues(category?.value, "Current Liabilities").map((category) => (
                  <div className="items-center" style={{ minWidth: "10em" }}>
                    <label>{CurrencyFormatter.format(category?.value, { code: "USD" })}</label>
                  </div>
                ))}
              </div>
              <div className="flex">
                <div className="whitespace-nowrap items-center" style={{ minWidth: "20em" }}>
                  <label className="text-xs">Ratio to Total Assets</label>
                </div>
                {currentCompanyMonthlyBalanceSheet?.getLiabilitiesCategoryValues(category?.value, "Current Liabilities").map((category, index) => (
                  <div className="items-center" style={{ minWidth: "10em" }}>
                    <label className="text-xs">
                      {(100 * category?.value / currentCompanyMonthlyBalanceSheet?.getTotalAssets()[index].value).toFixed(2)}%
                    </label>
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div className="flex items-center mt-2">
            <div className="whitespace-nowrap flex items-center border-t pt-4" style={{ minWidth: "20em" }}>
              <label className="font-semibold">Total Current Liabilities</label>
            </div>
            <div className="flex border-t pt-4">
              {currentCompanyMonthlyBalanceSheet?.getTotalLiabilities("Current Liabilities").map((asset) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
                </div>
              ))}
            </div>
          </div>
          <div className="flex items-center mt-1 pb-4">
            <div className="whitespace-nowrap flex items-center" style={{ minWidth: "20em" }}>
              <label className="text-xs">Ratio to Total Assets</label>
            </div>
            <div className="flex">
              {currentCompanyMonthlyBalanceSheet?.getTotalLiabilities("Current Liabilities").map((asset, index) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {(100 * asset?.value / currentCompanyMonthlyBalanceSheet?.getTotalAssets()[index].value).toFixed(2)}%
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <label className="font-bold text-xl">Long Term Liability</label>
        <div className="mt-5">
          {currentCompanyMonthlyBalanceSheet?.longTermLiabilityCategoryNames?.map((category, balanceSheetAssetItemIndex) => (
            <div key={balanceSheetAssetItemIndex} className="items-center mb-4">
              <div className="flex">
                <div className="whitespace-nowrap items-center" style={{ minWidth: "20em" }}>
                  <label>{category?.name}</label>
                </div>
                {currentCompanyMonthlyBalanceSheet?.getLiabilitiesCategoryValues(category?.value, "Long Term Liability").map((category) => (
                  <div className="items-center" style={{ minWidth: "10em" }}>
                    <label>{CurrencyFormatter.format(category?.value, { code: "USD" })}</label>
                  </div>
                ))}
              </div>
              <div className="flex">
                <div className="whitespace-nowrap items-center" style={{ minWidth: "20em" }}>
                  <label className="text-xs">Ratio to Total Assets</label>
                </div>
                {currentCompanyMonthlyBalanceSheet?.getLiabilitiesCategoryValues(category?.value, "Long Term Liability").map((category, index) => (
                  <div className="items-center" style={{ minWidth: "10em" }}>
                    <label className="text-xs">
                      {(100 * category?.value / currentCompanyMonthlyBalanceSheet?.getTotalAssets()[index].value).toFixed(2)}%
                    </label>
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div className="flex items-center mt-2">
            <div className="whitespace-nowrap flex items-center border-t pt-4" style={{ minWidth: "20em" }}>
              <label className="font-semibold">Total Long Term Liability</label>
            </div>
            <div className="flex border-t pt-4">
              {currentCompanyMonthlyBalanceSheet?.getTotalLiabilities("Long Term Liability").map((asset) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
                </div>
              ))}
            </div>
          </div>
          <div className="flex items-center mt-1 pb-4">
            <div className="whitespace-nowrap flex items-center" style={{ minWidth: "20em" }}>
              <label className="text-xs">Ratio to Total Assets</label>
            </div>
            <div className="flex">
              {currentCompanyMonthlyBalanceSheet?.getTotalLiabilities("Long Term Liability").map((asset, index) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {(100 * asset?.value / currentCompanyMonthlyBalanceSheet?.getTotalAssets()[index].value).toFixed(2)}%
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center mt-10">
        <div className="whitespace-nowrap flex items-center border-t pt-4" style={{ minWidth: "20em" }}>
          <label className="font-semibold">Total Liabilities</label>
        </div>
        <div className="flex">
          {currentCompanyMonthlyBalanceSheet?.getTotalLiabilities().map((asset) => (
            <div className="flex items-center border-t pt-4" style={{ minWidth: "10em" }}>
              <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center mt-1">
        <div className="whitespace-nowrap flex items-center border-b pb-4" style={{ minWidth: "20em" }}>
          <label className="text-xs">Ratio to Total Assets</label>
        </div>
        <div className="flex border-b pb-4">
          {currentCompanyMonthlyBalanceSheet?.getTotalLiabilities().map((asset, index) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label className="text-xs">
                {(100 * asset?.value / currentCompanyMonthlyBalanceSheet?.getTotalAssets()[index].value).toFixed(2)}%
              </label>
            </div>
          ))}
        </div>
      </div>

      {/*
      <div className="flex items-center">
        <div className="whitespace-nowrap flex items-center border-b py-4" style={{ minWidth: "20em" }}>
          <label className="font-semibold">Total Net Worth</label>
        </div>
        <div className="flex border-b py-4">
          {currentCompanyMonthlyBalanceSheet?.totalNetWorth?.map((asset) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center">
        <div className="whitespace-nowrap flex items-center border-b py-4" style={{ minWidth: "20em" }}>
          <label className="font-semibold">Total Liabilities & Net Worth</label>
        </div>
        <div className="flex border-b py-4">
          {currentCompanyMonthlyBalanceSheet?.totalLiabilitiesAndNetWorth?.map((asset) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
            </div>
          ))}
        </div>
      </div>
      */}

      <div className="mt-10">
        <label className="font-bold text-xl">Equity</label>
        <div className="mt-5">
          {currentCompanyMonthlyBalanceSheet?.equityCategoryNames?.map((category, balanceSheetAssetItemIndex) => (
            <div key={balanceSheetAssetItemIndex} className="items-center mb-4">
              <div className="flex">
                <div className="whitespace-nowrap items-center" style={{ minWidth: "20em" }}>
                  <label>{category?.name}</label>
                </div>
                {currentCompanyMonthlyBalanceSheet?.getEquitiesCategoryValues(category?.value).map((category) => (
                  <div className="items-center" style={{ minWidth: "10em" }}>
                    <label>{CurrencyFormatter.format(category?.value, { code: "USD" })}</label>
                  </div>
                ))}
              </div>
              <div className="flex">
                <div className="whitespace-nowrap items-center" style={{ minWidth: "20em" }}>
                  <label className="text-xs">Ratio to Total Assets</label>
                </div>
                {currentCompanyMonthlyBalanceSheet?.getEquitiesCategoryValues(category?.value).map((category, index) => (
                  <div className="items-center" style={{ minWidth: "10em" }}>
                    <label className="text-xs">
                      {(100 * category?.value / currentCompanyMonthlyBalanceSheet?.getTotalAssets()[index].value).toFixed(2)}%
                    </label>
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div className="flex items-center mt-2">
            <div className="whitespace-nowrap flex items-center border-t pt-4" style={{ minWidth: "20em" }}>
              <label className="font-semibold">Total Equity</label>
            </div>
            <div className="flex border-t pt-4">
              {currentCompanyMonthlyBalanceSheet?.getTotalEquities().map((asset) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
                </div>
              ))}
            </div>
          </div>
          <div className="flex items-center mt-1 pb-4">
            <div className="whitespace-nowrap flex items-center" style={{ minWidth: "20em" }}>
              <label className="text-xs">Ratio to Total Assets</label>
            </div>
            <div className="flex">
              {currentCompanyMonthlyBalanceSheet?.getTotalEquities().map((asset, index) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {(100 * asset?.value / currentCompanyMonthlyBalanceSheet?.getTotalAssets()[index].value).toFixed(2)}%
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/*
      <div className="flex items-center mt-10">
        <div className="whitespace-nowrap flex items-center border-t border-b py-4" style={{ minWidth: "20em" }}>
          <label className="font-semibold">Total Contributed Capital</label>
        </div>
        <div className="flex">
          {currentCompanyMonthlyBalanceSheet?.totalContributedCapital?.map((asset) => (
            <div className="flex items-center border-t border-b py-4" style={{ minWidth: "10em" }}>
              <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center">
        <div className="whitespace-nowrap flex items-center border-b py-4" style={{ minWidth: "20em" }}>
          <label className="font-semibold">Total Owner Distribution</label>
        </div>
        <div className="flex border-b py-4">
          {currentCompanyMonthlyBalanceSheet?.totalOwnerDistribution?.map((asset) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center">
        <div className="whitespace-nowrap flex items-center border-b py-4" style={{ minWidth: "20em" }}>
          <label className="font-semibold">Total Retained Earnings</label>
        </div>
        <div className="flex border-b py-4">
          {currentCompanyMonthlyBalanceSheet?.totalRetainedEarnings?.map((asset) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center">
        <div className="whitespace-nowrap flex items-center border-b py-4" style={{ minWidth: "20em" }}>
          <label className="font-semibold">Total Net Income</label>
        </div>
        <div className="flex border-b py-4">
          {currentCompanyMonthlyBalanceSheet?.totalNetIncome?.map((asset) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label className="font-semibold">{CurrencyFormatter.format(asset?.value, { code: "USD" })}</label>
            </div>
          ))}
        </div>
      </div>
      */}

    </div>
  )
}


const mapStateToProps = (state) => ({
  currentCompanyMonthlyBalanceSheet: state.financials.currentCompanyMonthlyBalanceSheet
})

export default connect(mapStateToProps)(MonthlyBalanceSheetConsolidation)